export default {"src":"/_next/static/media/tensorflow.a44ae670.svg","height":287,"width":256,"blurWidth":0,"blurHeight":0};